/* Spicy Cubes LP — reveal animation, bundle picker, add to cart, UGC video */
(function(){
  if (window.__sclpInit) { window.__sclpInit(document); return; }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: .1 }) : null;
  function initReveal(root){
    root.querySelectorAll('.sclp-anim [data-sclp-reveal]').forEach(function(el){
      if (el.__sclp) return; el.__sclp = 1;
      var sib = Array.prototype.filter.call(el.parentElement.children, function(c){ return c.hasAttribute('data-sclp-reveal'); });
      var i = Math.min(6, Math.max(0, sib.indexOf(el)));
      el.style.setProperty('--rd', (i * 90) + 'ms');
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }
  function selectBundle(buy, btn){
    if (!buy || !btn) return;
    buy.querySelectorAll('.sclp-bundle').forEach(function(b){ b.classList.toggle('is-active', b === btn); b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
    var atc = buy.querySelector('.sclp-atc');
    if (atc){ atc.textContent = btn.dataset.cta; }
  }
  function initBuy(root){
    root.querySelectorAll('[data-sclp-buy]').forEach(function(buy){
      if (buy.__sclp) return; buy.__sclp = 1;
      buy.querySelectorAll('.sclp-bundle').forEach(function(b){ b.addEventListener('click', function(){ selectBundle(buy, b); }); });
      var atc = buy.querySelector('.sclp-atc');
      if (!atc) return;
      atc.addEventListener('click', function(){
        var sel = buy.querySelector('.sclp-bundle.is-active') || buy.querySelector('.sclp-bundle');
        if (!sel || !sel.dataset.variant) return;
        atc.disabled = true;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(sel.dataset.variant), quantity: Number(sel.dataset.qty || 1) }] })
        }).then(function(r){ if (!r.ok) throw r; return r.json(); }).then(function(){
          atc.disabled = false; atc.textContent = buy.dataset.added || 'Added to cart ✓';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          var after = buy.dataset.after;
          if (after === 'checkout') window.location.href = base + 'checkout';
          else if (after === 'cart') window.location.href = base + 'cart';
        }).catch(function(){ atc.disabled = false; window.location.href = base + 'cart/' + sel.dataset.variant + ':' + (sel.dataset.qty || 1); });
      });
    });
  }
  function initPick(root){
    root.querySelectorAll('[data-sclp-pick]').forEach(function(a){
      if (a.__sclp) return; a.__sclp = 1;
      a.addEventListener('click', function(){
        var n = parseInt(a.dataset.sclpPick, 10); if (!n) return;
        var buy = document.querySelector('[data-sclp-buy]'); if (!buy) return;
        selectBundle(buy, buy.querySelectorAll('.sclp-bundle')[n - 1]);
      });
    });
  }
  function initUgc(root){
    root.querySelectorAll('.sclp-ugc-media[data-video]').forEach(function(m){
      if (m.__sclp) return; m.__sclp = 1;
      m.addEventListener('click', function(){
        var v = m.querySelector('video'); if (!v) return;
        if (v.paused){ v.play(); m.classList.add('is-playing'); v.controls = true; } else { v.pause(); }
      });
    });
  }
  window.__sclpInit = function(root){ root = root || document; initReveal(root); initBuy(root); initPick(root); initUgc(root); };
  function boot(){ window.__sclpInit(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ window.__sclpInit(e.target); });
})();